// extracted by mini-css-extract-plugin
export default {"circle":"Circle__circle--bh9Gy"};